import {ViewAsStorageKey} from '../constants/ViewAsStorageKey'
import {IViewAsState} from '../types/IViewAsState'

export function writeViewAsStateToStorage(state: IViewAsState): void {
  if(typeof sessionStorage === 'undefined') {
    return
  }
  try {
    sessionStorage.setItem(ViewAsStorageKey, JSON.stringify(state))
  } catch {
    return
  }
}
